import React, { useContext, useState, useEffect } from "react";
import { store } from "../store";
import { Row, Col } from 'antd';
import { Text, View, FlatList, Pressable, ScrollView, TextInput, Image, Dimensions, Modal } from 'react-native-web';
import { themeColor } from "../config/servervar";
import { ViewList, ViewDetail } from '../component/listdetail';
import { CustomIcon } from "../component/custom";
import EventEmitter from "../component/EventEmitter";
import { useDebounce } from "../component/custom";
import axios from 'axios'
import { server_var } from "../config/servervar";


const LIST_DEFINE = [
  { id: 1, field1: 'id', flex: 0.1, textAlign: 'left', headerTitle: 'ID' },
  { id: 2, field1: 'shopIdBranch', flex: 0.2, textAlign: 'left', headerTitle: 'รหัสร้าน' },
  { id: 3, field1: 'shopThName', flex: 0.6, textAlign: 'left', headerTitle: 'ชื่อร้าน' },
  { id: 4, field1: 'shopMobileNumber', flex: 0.2, textAlign: 'left', headerTitle: 'เบอร์โทรมือถือ' },
  { id: 5, field1: 'shopStatus', flex: 0.1, textAlign: 'left', headerTitle: 'Status' },
];

const DETAIL_DEFINE = [
  {
    id: 1, fieldName: 'id', displayName: 'ID', newValue: 0, controlOption: {
      textInputStyle: { backgroundColor: 'lightgray' }, textInputProp: { editable: false }
    }
  },
  { id: 2, fieldName: 'shopIdBranch', displayName: 'รหัสร้าน', newValue: '' },
  { id: 3, fieldName: 'shopThName', displayName: 'ชื่อร้าน(Th)', newValue: '' },
  { id: 4, fieldName: 'shopEnName', displayName: 'ชื่อร้าน(En)', newValue: '' },
  { id: 5, fieldName: 'shopTel', displayName: 'เบอร์โทร', newValue: '' },
  { id: 6, fieldName: 'shopMobileNumber', displayName: 'เบอร์มือถือ', newValue: '' },
  { id: 7, fieldName: 'shopEmail', displayName: 'Email', newValue: '' },
  { id: 8, fieldName: 'shopLineId', displayName: 'Line ID', newValue: '' },
  { id: 9, fieldName: 'shopLineLink', displayName: 'Line Link', newValue: '' },
  { id: 10, fieldName: 'shopLineQr', displayName: 'Line Qr', newValue: '' },
  { id: 11, fieldName: 'shopLat', displayName: 'Latitude', newValue: '' },
  { id: 12, fieldName: 'shopLong', displayName: 'Longitude', newValue: '' },
  { id: 13, fieldName: 'shopOpenCloseTime', displayName: 'เวลาเปิดปิด', newValue: '', controlOption: { textInputStyle: { height: 80 }, textInputProp: { multiline: true } } },
  { id: 14, fieldName: 'shopThAddress', displayName: 'ที่อยู่(Th)', newValue: '', controlOption: { textInputStyle: { height: 80 }, textInputProp: { multiline: true } } },
  { id: 15, fieldName: 'shopEnAddress', displayName: 'ที่อยู่(En)', newValue: '', controlOption: { textInputStyle: { height: 80 }, textInputProp: { multiline: true } } },
  {
    id: 12, fieldName: 'shopStatus', displayName: 'สถานะ', newValue: 'verified', controlType: 'dropdown', controlOption: {
      list: [
        { id: 1, title: 'verified', value: 'verified' }, { id: 2, title: 'inactive', value: 'inactive' }
      ]
    }
  },
  {
    id: 17, fieldName: 'memberlist', displayName: 'สมาชิก', newValue: [], controlType: 'component', component: (props) => <MemberCom {...props} />
  },
];

const QUERY_NAME = 'shops';
const QUERY_CON = { $select: ['id', 'shopIdBranch', 'shopThName', 'shopTel', 'shopMobileNumber', 'shopStatus'] };

export const Shop = () => {
  const [selectIndex, setSelectIndex] = useState(-1);
  const [queryParams, setQueryParams] = useState();
  const { globalState } = useContext(store);

  const downloadTxtFile = async () => {
    const res = await axios.post(`${server_var.server_api}/extractShop`, queryParams)
    if (res?.data?.csv) {
      console.log('texts', res.data.csv);
      const file = new Blob([res.data.csv], { type: 'text/plain' });
      const element = document.createElement("a");
      element.href = URL.createObjectURL(file);
      element.download = "shop" + Date.now() + ".csv";
      document.body.appendChild(element);
      element.click();
    } else if (res.data.message) {
      alert(res.data.message);
    } else {
      alert('มีข้อผิดพลาดเกิดขึ้น')
    }
  }

  const onChangeQuery = (queryParams) => {
    setQueryParams(queryParams);
  }

  return (
    <Row style={{ flex: 1, flexWrap: 'wrap' }}>
      <Col span={12} style={{ height: '100vh', padding: 5 }}>
        <ViewList
          onPress={id => setSelectIndex(id)}
          listDefine={LIST_DEFINE}
          queryName={QUERY_NAME} queryCon={QUERY_CON}
          onChangeQuery={onChangeQuery}
          viewListOption={{
            topControlList: [
              { id: 2, title: 'Search', type: 'multi_column_search', searchField: ['shopThName', 'shopIdBranch'], placeholder: 'ค้นหาตามชื่อร้าน/รหัสร้าน', textInputStyle: { width: 300 } },
              {
                id: 3, title: '', type: 'dropdown', searchField: 'shopStatus', list: [
                  { id: 1, title: 'verified', value: 'verified' },
                  { id: 2, title: 'inactive', value: 'inactive' },
                ]
              },
              { id: 4, title: 'Export', type: 'button', onPress: () => downloadTxtFile() },
            ]
          }}
        />
      </Col>
      <Col span={12} style={{
        height: '100vh', padding: 5,
        borderWidth: 1, borderLeftStyle: 'solid', borderColor: 'gray'
      }}>
        <ViewDetail
          selectIndex={selectIndex}
          detailDefine={DETAIL_DEFINE}
          queryName={QUERY_NAME}
          queryCon={{ $notInclude: true }}
          viewDetailOption={{ hideDelete: false }}
          onDeletePress={async (id) => {
            await globalState.client.service('shopusers').remove(null, { query: { shopId: id } });
          }}
          onSavePress={(id) => {
            EventEmitter.notify('MemberCom::save', { shopId: id });
            setSelectIndex(-1)
          }}
        />
      </Col>
    </Row>
  )
}

function MemberCom({ data }) {
  const { globalState } = useContext(store);
  const [memberList, setMemberList] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const dataJson = data.reduce((acc, item3) => ({ ...acc, [item3[0]]: item3[1] }), {});

  useEffect(() => {
    if (dataJson?.id > 0) {
      loadData();
      return;
    }
    if (dataJson?.id == 0) {
      setMemberList([])
    }
  }, [dataJson?.id]);

  useEffect(() => {
    EventEmitter.addListener('MemberCom::save', saveMemberCom);
    EventEmitter.addListener('MemberCom::add', addMemberCom);
    return () => {
      EventEmitter.removeListener('MemberCom::save', saveMemberCom);
      EventEmitter.removeListener('MemberCom::add', addMemberCom);
    };
  }, [dataJson?.id, memberList])

  const saveMemberCom = async (payload) => {
    await globalState.client.service('shopusers').remove(null, { query: { shopId: dataJson?.id } });
    await globalState.client.service('shopusers').create(
      // memberList.map(item3 => ({ shopId: dataJson?.id, userId: item3.userId, statusOnline: 'offline' }))
      memberList.map(item3 => ({ shopId: payload.shopId, userId: item3.userId, statusOnline: 'offline' }))
    );
  }

  const addMemberCom = (payload) => {
    if (memberList?.filter(item4 => item4.userId == payload.userId).length == 0) {
      setMemberList(prev => ([...prev, { ...payload, shopId: dataJson?.id }]))
    }
  }

  const loadData = async () => {
    console.log('load1');
    const res = await globalState.client.service('shopusers').find({ query: { shopId: dataJson?.id } })
    setMemberList(res.data)
    console.log('load2', res.data);
  }
  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
      {memberList?.map(item6 => (
        <View key={item6.id.toString()} style={{ alignItems: 'center' }}>
          <Image source={{ uri: item6.user.avatar }} style={{ width: 60, height: 60, borderRadius: 30, marginHorizontal: 10 }} />
          <Text style={{ marginTop: 5 }}>{item6?.user?.displayName}</Text>
          <Pressable style={{ position: 'absolute', top: 0, right: 0 }}
            onPress={() => setMemberList(prev => {
              const tmp1 = [...prev].filter(item7 => item7.id != item6.id);
              return tmp1;
            })}
          >
            <CustomIcon name="close-circle" size={20} color={'red'} />
          </Pressable>
        </View>
      ))}
      <Pressable
        onPress={() => setShowDialog(true)}
        style={{ marginHorizontal: 10 }}
      >
        <View style={{ width: 60, height: 60, justifyContent: 'center', alignItems: 'center' }}>
          <CustomIcon name="plus-circle" size={40} color={themeColor.color1} />
        </View>
      </Pressable>
      <Dialog showDialog={showDialog} setShowDialog={setShowDialog}>
        <DialogAddMember />
      </Dialog>
    </View>
  )
}

function Dialog({ showDialog, setShowDialog, children }) {
  return (
    <Modal visible={showDialog} transparent={true}>
      <View style={{
        position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        justifyContent: 'center', alignItems: 'center'
      }}>
        <View style={{
          backgroundColor: 'white',
          paddingHorizontal: 20, paddingVertical: 20, borderRadius: 10
        }}>
          <Pressable style={{ position: 'absolute', top: 0, right: 0 }} onPress={() => setShowDialog(false)}>
            <CustomIcon name="close-circle" size={30} color="gray" />
          </Pressable>
          {children}
        </View>
      </View>
    </Modal>
  )
}

function DialogAddMember() {
  const { globalState } = useContext(store);
  const [dataList, setDataList] = useState([]);
  const [skip, setSkip] = useState(0)
  const [loading, setLoading] = useState(false);
  const dialogWidth = Dimensions.get('window').width / 3;
  const dialogHeight = Dimensions.get('window').height / 1.5
  const [searchText, setSearchText] = useState('');
  const debSearchText = useDebounce(searchText, 1000);

  useEffect(() => {
    loadDataList(0)
  }, [debSearchText])

  const loadDataList = async (pSkip) => {
    if (!loading) {
      setLoading(true);
      let res;
      let query = {
        displayName: { $like: `%${searchText}%` },
        staffFlag: 1,
        $skip: pSkip ?? skip, $sort: { id: 1 }
      }

      try {
        res = await globalState.client.service('users').find({ query });
      } catch { }
      if (res) {
        if ((pSkip ?? skip) === 0) {
          setDataList(res.data);
        } else {
          setDataList(prev => [...prev, ...res.data]);
        }
        setSkip((res.skip + res.limit));
      }
      setLoading(false);
    }
  }

  return (
    <View>
      <TextInput
        value={searchText}
        onChangeText={text => setSearchText(text)}
        style={{ borderWidth: 1, borderColor: 'lightgray', height: 40, width: dialogWidth - 40, paddingHorizontal: 10 }}
      />
      <FlatList
        keyExtractor={(item) => item.id.toString()}
        style={{ marginTop: 10, height: (dialogHeight) - 70 }}
        data={dataList}
        onEndReached={(xxx) => loadDataList()}
        onEndReachedThreshold={0.5}
        onRefresh={() => loadDataList(0)}
        refreshing={(loading && skip == 0)}
        renderItem={({ item }) => <AddMemberItem item={item} />}
      />
    </View>
  )
}

function AddMemberItem({ item }) {
  return (
    <Pressable style={{ marginVertical: 20 }} onPress={() => {
      EventEmitter.notify('MemberCom::add', {
        id: Date.now(), userId: item.id, user: { id: item.id, avatar: item.avatar, displayName: item.displayName }
      })
    }}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Image source={{ uri: item.avatar }} style={{ width: 60, height: 60, borderRadius: 30 }} />
        <Text style={{ marginLeft: 20 }}>{item.displayName}</Text>
      </View>
    </Pressable>
  )
}

